"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["data-id", "id", "data-tags"];
const _hoisted_2 = { class: "name-container align-center flex-gap" };
const _hoisted_3 = ["href"];
const _hoisted_4 = {
    class: "tooltip tooltip-right circle-container alert-badge over-max-vacation d-none",
    "data-tooltip": "月休み希望数を超えています。"
};
const _hoisted_5 = {
    version: "1.1",
    class: "airplane",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 35",
    width: "8px",
    height: "8px",
    style: { "enable-background": "new 0 0 35 35" },
    "xml:space": "preserve"
};
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("path", {
    fill: "currentColor",
    d: "M29.3,9.1l-5.5,5.8,4.2,15.3-1.2,1.3-7.2-12.1-5.6,5.9-.8.5.9,5.6-1.2,1.3-2.4-4.2-.7-.7c-.6.2-1,.3-1.2.1-.1-.1,0-.6.2-1.2l-.7-.8-3.9-2.6,1.2-1.2,5.3,1,.5-1,5.6-5.9-11.4-7.6,1.2-1.3,14.3,4.5,5.4-5.8c.8-.9,2.7-1.5,3.5-.7.8.9.2,2.9-.6,3.8Z"
}, null, -1 /* HOISTED */);
const _hoisted_7 = [
    _hoisted_6
];
const _hoisted_8 = {
    class: "tooltip tooltip-right circle-container alert-badge over-max-month d-none",
    "data-tooltip": "月最大労務：超過"
};
const _hoisted_9 = {
    version: "1.1",
    class: "up_arrow",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 35",
    width: "8px",
    height: "8px",
    style: { "enable-background": "new 0 0 35 35" },
    "xml:space": "preserve"
};
const _hoisted_10 = /*#__PURE__*/ (0, vue_2.createElementVNode)("path", {
    fill: "currentColor",
    d: "M8.7,31.1h17.6v-13.4h6.4L17.5,3,2.2,17.7h6.4v13.4Z"
}, null, -1 /* HOISTED */);
const _hoisted_11 = [
    _hoisted_10
];
const _hoisted_12 = {
    class: "tooltip tooltip-right circle-container alert-badge under-min-month d-none",
    "data-tooltip": "月最低労務：不足"
};
const _hoisted_13 = {
    version: "1.1",
    class: "down_arrow",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 35",
    width: "8px",
    height: "8px",
    style: { "enable-background": "new 0 0 35 35" },
    "xml:space": "preserve"
};
const _hoisted_14 = /*#__PURE__*/ (0, vue_2.createElementVNode)("path", {
    fill: "currentColor",
    d: "M26.3,4.1H8.7v13.4H2.2l15.3,14.8,15.3-14.8h-6.4V4.1Z"
}, null, -1 /* HOISTED */);
const _hoisted_15 = [
    _hoisted_14
];
const _hoisted_16 = {
    key: 0,
    class: "tag-container"
};
const _hoisted_17 = { class: "tag-box text-ellipsis" };
const _hoisted_18 = {
    key: 0,
    class: "text-center memo-text"
};
const _hoisted_19 = ["id", "data-date", "data-user"];
const _hoisted_20 = ["id"];
const _hoisted_21 = ["id"];
const _hoisted_22 = {
    key: 0,
    class: "zmdi zmdi-lock"
};
const _hoisted_23 = ["id"];
const _hoisted_24 = {
    key: 0,
    class: "zmdi zmdi-lock"
};
const _hoisted_25 = ["id"];
const _hoisted_26 = {
    key: 0,
    class: "zmdi zmdi-lock"
};
const _hoisted_27 = ["id"];
const _hoisted_28 = {
    key: 0,
    class: "zmdi zmdi-lock"
};
const vue_3 = require("vue");
const SummaryTableEmployeeDateCellView_vue_1 = __importDefault(require("./SummaryTableEmployeeDateCellView.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SummaryTableEmployeeRowView',
    props: {
        employee: {
            required: true,
            type: Object,
        },
        dates: {
            required: true,
            type: Array,
        },
        stats: {
            required: false,
            type: Object,
        },
        showDataCells: {
            required: true,
            type: Boolean,
        }
    },
    setup(__props) {
        const props = __props;
        const userId = (0, vue_3.computed)(() => {
            return props.employee.userId;
        });
        const name = (0, vue_3.computed)(() => {
            return props.employee.name;
        });
        // Needed?
        const dataTags = (0, vue_3.computed)(() => {
            return props.employee.tags.join(" ");
        });
        const nameClasses = (0, vue_3.computed)(() => {
            return {
                "text-success": props.employee.isBranchOwner,
                "text-gray": props.employee.isFake,
                "text-error": props.employee.isDeleted,
                "text-warning": props.employee.isHelp,
            };
        });
        const userHref = (0, vue_3.computed)(() => {
            return props.employee.link;
        });
        const roleCounts = (0, vue_3.computed)(() => {
            return props.stats?.roleCounts || [];
        });
        const showAlertBadges = (0, vue_3.computed)(() => {
            return props.stats?.showUserAlertBadges ?? false;
        });
        const showStatsLock = (0, vue_3.computed)(() => {
            return props.stats?.showStatsLock ?? true;
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                class: "summary-users-row user-row",
                "data-id": userId.value,
                id: `${userId.value}`,
                "data-tags": dataTags.value
            }, [
                (0, vue_2.createElementVNode)("td", {
                    class: (0, vue_2.normalizeClass)(["name text-popup name-tag-container pb-0 pt-0", nameClasses.value])
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createElementVNode)("a", {
                            class: "no-color user-link text-ellipsis",
                            href: userHref.value
                        }, (0, vue_2.toDisplayString)(name.value), 9 /* TEXT, PROPS */, _hoisted_3),
                        (0, vue_2.createCommentVNode)(" Currently, these badges act as placeholders for document selectors in other files. Must provide exact classnames. "),
                        (showAlertBadges.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: 0,
                                class: (0, vue_2.normalizeClass)(["user-alert-badges", { 'd-none': !__props.showDataCells }])
                            }, [
                                (0, vue_2.createCommentVNode)(" OverMaxVacation "),
                                (0, vue_2.createElementVNode)("span", _hoisted_4, [
                                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("svg", _hoisted_5, _hoisted_7))
                                ]),
                                (0, vue_2.createCommentVNode)(" OverMaxMonth "),
                                (0, vue_2.createElementVNode)("span", _hoisted_8, [
                                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("svg", _hoisted_9, _hoisted_11))
                                ]),
                                (0, vue_2.createCommentVNode)(" UnderMinMonth "),
                                (0, vue_2.createElementVNode)("span", _hoisted_12, [
                                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("svg", _hoisted_13, _hoisted_15))
                                ])
                            ], 2 /* CLASS */))
                            : (0, vue_2.createCommentVNode)("v-if", true)
                    ]),
                    (__props.employee.tags.length)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_16, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(props.employee.tags, (tag) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_17, (0, vue_2.toDisplayString)(tag), 1 /* TEXT */));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true)
                ], 2 /* CLASS */),
                (__props.employee.showMemoSummary && __props.showDataCells)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_18, (0, vue_2.toDisplayString)(__props.employee.memo), 1 /* TEXT */))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (0, vue_2.createCommentVNode)(" safe to remove class date-{{date.dateString}}? "),
                (__props.showDataCells)
                    ? ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, (0, vue_2.renderList)(__props.dates, (date) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                            class: "list dropzone relative",
                            id: `date-${userId.value}_${date}`,
                            "data-date": date,
                            "data-user": userId.value
                        }, [
                            (0, vue_2.createVNode)(SummaryTableEmployeeDateCellView_vue_1.default, {
                                userId: userId.value,
                                "date-string": date
                            }, null, 8 /* PROPS */, ["userId", "date-string"])
                        ], 8 /* PROPS */, _hoisted_19));
                    }), 256 /* UNKEYED_FRAGMENT */))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (0, vue_2.createCommentVNode)(" Currently, these cells act as placeholders for document selectors in other files. Must provide exact id. "),
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(roleCounts.value, (roleCount) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                        id: `role-count-${roleCount.id}-${userId.value}-count`,
                        class: (0, vue_2.normalizeClass)(["bg-gray text-center", { 'd-none': !__props.showDataCells }])
                    }, " - ", 10 /* CLASS, PROPS */, _hoisted_20));
                }), 256 /* UNKEYED_FRAGMENT */)),
                (__props.stats?.showEmployeeWorkCountCell)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                        key: 2,
                        id: showStatsLock.value ? '' : `work-count-${userId.value}`,
                        class: (0, vue_2.normalizeClass)(["bg-gray text-center", { 'd-none': !__props.showDataCells }])
                    }, [
                        (showStatsLock.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_22))
                            : (0, vue_2.createCommentVNode)("v-if", true)
                    ], 10 /* CLASS, PROPS */, _hoisted_21))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (__props.stats?.showEmployeeVacationCountCell)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                        key: 3,
                        id: showStatsLock.value ? '' : `vacation-count-${userId.value}`,
                        class: (0, vue_2.normalizeClass)(["bg-gray text-center", { 'd-none': !__props.showDataCells }])
                    }, [
                        (showStatsLock.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_24))
                            : (0, vue_2.createCommentVNode)("v-if", true)
                    ], 10 /* CLASS, PROPS */, _hoisted_23))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (__props.stats?.showEmployeePTOCountCell)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                        key: 4,
                        id: showStatsLock.value ? '' : `pto-count-${userId.value}`,
                        class: (0, vue_2.normalizeClass)(["bg-gray text-center", { 'd-none': !__props.showDataCells }])
                    }, [
                        (showStatsLock.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_26))
                            : (0, vue_2.createCommentVNode)("v-if", true)
                    ], 10 /* CLASS, PROPS */, _hoisted_25))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (__props.stats?.showEmployeeLaborCountCell)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                        key: 5,
                        id: showStatsLock.value ? '' : `labor-hours-${userId.value}`,
                        class: (0, vue_2.normalizeClass)(["bg-gray text-center", { 'd-none': !__props.showDataCells }])
                    }, [
                        (showStatsLock.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_28))
                            : (0, vue_2.createCommentVNode)("v-if", true)
                    ], 10 /* CLASS, PROPS */, _hoisted_27))
                    : (0, vue_2.createCommentVNode)("v-if", true)
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
